export const blogTypes = {
    set: 'BLOG/SET_BLOG',
    setTag: 'BLOG/SET_TAG',
}
